module.exports = __webpack_public_path__ + "static/media/3XL.7447cd85.jpg";